module.exports = __webpack_public_path__ + "img/sign-14.0cc8a2cb.jpg";